import * as React from 'react';

const SvgCheckHistoryOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M18.108 6.268a8.85 8.85 0 0 1-6.258 15.108.75.75 0 1 1 0-1.5 7.35 7.35 0 0 0 0-14.7.75.75 0 1 1 0-1.5 8.85 8.85 0 0 1 6.258 2.592m-2.807 3.254a.75.75 0 0 1 .158 1.049L11.457 16a.75.75 0 0 1-1.139.08l-2.334-2.375a.75.75 0 1 1 1.07-1.052l1.636 1.664a.1.1 0 0 0 .151-.01l3.41-4.627a.75.75 0 0 1 1.05-.159m-8-4.877a1 1 0 0 0 1 1.732l.038-.022a1 1 0 1 0-.99-1.739zM4.334 9.342a1 1 0 0 1-.366-1.366l.029-.05a1 1 0 0 1 1.726 1.011l-.023.039a1 1 0 0 1-1.366.366M2.75 12.526a1 1 0 1 0 2 0v-.045a1 1 0 0 0-2-.012zm2.585 4.916a1 1 0 0 1-1.366-.366l-.028-.05a1 1 0 1 1 1.738-.989l.022.039a1 1 0 0 1-.366 1.366M7.3 20.407a1 1 0 0 0 1-1.732l-.038-.023a1 1 0 0 0-1.011 1.726z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgCheckHistoryOutlined;
